import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock';

window.menu = () => {
    return {
        open: false,
        toggle($el) {
            this.open = !this.open
            if (this.open) {
                disableBodyScroll($el);
            } else {
                enableBodyScroll($el);
            }
        }
    }
}
